export enum TiimeBusinessProAccountIntention {
  interested = 'yes',
  notInterested = 'no',
  undecided = 'undecided'
}
